module.exports = __webpack_public_path__ + "img/12.9a257cf2.png";